export const PICKUP_LOCATIONS_ROUTE = 'pickupLocations';

export const PICKUP_LOCATIONS_FIELDS = {
  CHECK_PICKUP_LOCATION: 'checkPickupLocation',
};
